module.exports = __webpack_public_path__ + "img/close-btn.a904dc7d.svg";